export default {
  productList: {
    name: "groupon product list api",
    version: 6,
    url: "groupon/products",
    method: "GET",
  },
  productAdd: {
    name: "groupon product add api",
    version: 6,
    url: "groupon/products",
    method: "POST",
  },
  productUpdate: {
    name: "groupon product update api",
    version: 6,
    url: "groupon/products/%{id}",
    method: "PUT",
  },
  productDelete: {
    name: "groupon product delete api",
    version: 6,
    url: "groupon/products/%{id}",
    method: "DELETE",
  },
  orderList: {
    name: "groupon order list api",
    version: 6,
    url: "groupon/orders",
    method: "GET",
  },
  orderShow: {
    name: "groupon order show api",
    version: 6,
    url: "groupon/orders/%{id}",
    method: "GET",
  },
  orderRefund: {
    name: "groupon order refund api",
    version: 6,
    url: "groupon/orders/%{id}/refund",
    method: "POST",
  },
  preVerify: {
    name: "groupon pre verify api",
    version: 6,
    url: "groupon/verify/pre-verify",
    method: "POST",
  },
  verify: {
    name: "groupon verify api",
    version: 6,
    url: "groupon/verify/verify",
    method: "POST",
  },
  stats: {
    name: "groupon stats api",
    version: 6,
    url: "groupon/stats",
    method: "GET",
  },
};
